// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__UNEJU","preloader":"Preloader_preloader__48lHV","spin":"Preloader_spin__9q8UO"};